import { useMutation, useQueryClient } from '@tanstack/react-query'

import { showErrorToast } from 'common/api/helpers'
import { successToast } from 'common/components/toastNotification'

import { deleteProductCatalog } from '../api'
import { keys as dataSourcesKeys } from '../queryKeys'

type DeleteProductCatalogVariables = {
  accountId: string
  productCatalogId: string
  region: string
}

const useDeleteProductCatalogMutation = () => {
  const queryClient = useQueryClient()

  return useMutation<void, Error, DeleteProductCatalogVariables>(
    deleteProductCatalog,
    {
      onSuccess: (_, variables) => {
        successToast('Catalogue deleted successfully.')
        queryClient.invalidateQueries(
          dataSourcesKeys.productCatalogs(variables)
        )
      },
      onError: (error) => {
        showErrorToast(error)
      },
    }
  )
}

export default useDeleteProductCatalogMutation
